<template>
  <div>
    <template v-if="isFeed && isInternalLink">
      <post-attachment :attachment="attachment" :message="message" />
    </template>

    <template v-else>
      <collection-item
        :no-uppercase="!isInternalLink"
        :unlock="isInternalLink ? null : true"
        card-style="raised"
        :page-id="attachment.page_id"
        :title="attachment.title ? attachment.title : attachment.url"
        :content-type="
          isInternalLink
            ? attachment.type
            : attachment.title
            ? attachment.url
            : ''
        "
        :card-display="cardDisplay"
        :modifiers="modifiers"
        :to="isPresent(attachment.path) ? attachment.path : attachment.url"
        class="attachment-item"
      >
        <template v-slot:image>
          <div
            :class="[
              { 'subscriber-avatar': !hasAttachmentImage },
              'attachment-image'
            ]"
          >
            <img :src="attachmentImage" />
          </div>
        </template>
      </collection-item>
    </template>
  </div>
</template>

<script>
import { isPresent } from "@/lib/utils"

export default {
  components: {
    PostAttachment: () => import("@/components/message-thread/PostAttachment"),
    CollectionItem: () => import("@/components/CollectionItem")
  },

  props: {
    message: { type: Object, required: true },
    attachment: { type: Object, required: true },
    user: { type: Object, default: null },
    isFeed: { type: Boolean, default: false }
  },

  data() {
    return {
      isFetchingPage: false
    }
  },

  computed: {
    isInternalLink() {
      return (
        isPresent(this.attachment.page_id) && !this.attachment.is_legacy_type
      )
    },

    pageId() {
      return isPresent(this.attachment) ? this.attachment.page_id : null
    },

    title() {
      return this.attachment?.title
    },

    attachmentImage() {
      return this.hasAttachmentImage
        ? this.attachment.image
        : this.user?.avatar_urls?.sm
    },

    hasAttachmentImage() {
      return isPresent(this.attachment) && isPresent(this.attachment.image)
    },

    cardDisplay() {
      return this.hasAttachmentImage ? "vertical" : "horizontal"
    },

    modifiers() {
      return isPresent(this.pageId) || isPresent(this.attachmentImage)
        ? ""
        : "no-image"
    }
  },

  methods: {
    isPresent
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables";
@import "@/assets/styles/mixins";

.attachment-preview {
  border-radius: 8px;
  box-shadow: $box-shadow--medium;
  overflow: hidden;

  &__wrapper {
    @include hide-scroll-bars;

    height: 400px;
    overflow: scroll;
    mask-image: linear-gradient(
      to top,
      rgba(0, 0, 0, 0) 0%,
      rgb(255, 255, 255) 12%
    );

    iframe {
      width: 100%;
      height: 100vh;
      border: none;
      pointer-events: none;
    }
  }

  &__footer {
    display: flex;
    padding: 1rem;
    align-items: center;
    justify-content: space-between;
    color: $color-ui--black;
    font-size: 14px;
    font-weight: 600;

    .v-icon {
      font-weight: 600;
    }
  }
}
</style>

<style lang="scss">
@import "@/assets/styles/variables";

.attachment-item.collection-item {
  &.--completed {
    .collection-item__content {
      opacity: 1;
    }
  }

  .collection-item__type {
    letter-spacing: 0;
  }
}

.message-thread.--feed {
  .attachment-preview__wrapper {
    height: 100%;
    max-height: calc(650px - $size--13);
  }
}
</style>
